import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

import { development } from "lib/paths";

// Firebase configuration
var firebaseConfig = development
  ? {
      // Development
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY_DEV,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_DEV,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_DEV,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_DEV,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_DEV,
      appId: process.env.REACT_APP_FIREBASE_APP_ID_DEV,
    }
  : {
      // Production
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY_PROD,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_PROD,
      databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL_PROD,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_PROD,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_PROD,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_PROD,
      appId: process.env.REACT_APP_FIREBASE_APP_ID_PROD,
    };

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export default firebase;
